import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const DamacHills2Page = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
    agreement: false
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission
    console.log('Form submitted:', formData);
  };

  const amenities = [
    {
      title: "Malibu Beach",
      description: "Soak up the sun, where beach vibes blend with water park thrills. Dive into the waves, lounge on the sand, and nearby attractions for endless fun.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Amenities-02-Lazy-River-4x3.jpg"
    },
    {
      title: "Lazy River",
      description: "Drift along our serene lazy river, where gentle currents lead you through a scenic oasis, offering a perfect escape for relaxation and natural beauty.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Amenities-04-Zen-Garden-4x3.jpg"
    },
    {
      title: "Paintball Park",
      description: "Gear up for an adrenaline-filled adventure at the paintball park, where friendly competition and teamwork create exciting moments for all to enjoy.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Gallery-01.jpg"
    },
    {
      title: "Zen Garden",
      description: "Find peace and serenity in this tranquil space, where nature's harmony surrounds you, offering the perfect escape for quiet reflection and relaxation.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Gallery-02.jpg"
    },
    {
      title: "Floating Cinema",
      description: "Enjoy the magic of movies under the stars at our outdoor cinema, where a cosy ambiance and open-air setting create an unforgettable experience.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Gallery-00.jpg"
    },
    {
      title: "Fishing Lake",
      description: "Find your peaceful escape by the water, where you can relax, cast a line, and create memories with loved ones.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Social_Image_9x16-1.jpg"
    },
    {
      title: "Sports Fields",
      description: "Whether it's tennis, padel, volleyball, or football, our courts are ready for action. Push your limits, share great moments, and feel the excitement of the game.",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Social_Image_9x16-2.jpg"
    }
  ];

  const featuredProjects = [
    {
      name: "ELO 3",
      location: "Dubailand, Dubai",
      price: "From AED 1,311,000",
      type: "2 Bedrooms, Apartment",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Gallery-01.jpg"
    },
    {
      name: "Violet 4",
      location: "Dubailand, Dubai",
      price: "",
      type: "",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Gallery-02.jpg"
    },
    {
      name: "ELO 2",
      location: "Dubailand, Dubai",
      price: "From AED 1,327,000",
      type: "2 Bedrooms, Apartment",
      image: "/damac/DamacHills 2/DAMAC_Hills_2-Gallery-00.jpg"
    }
  ];

  const faqs = [
    {
      question: "Where is the location of DAMAC Hills 2 (AKOYA)?",
      answer: "DAMAC Hills 2 is located in Dubailand, Dubai, offering easy access to major highways and key destinations."
    },
    {
      question: "What unit types are offered in DAMAC Hills 2 (AKOYA)?",
      answer: "The community offers a variety of unit types including apartments, townhouses, and villas to suit different lifestyle needs."
    },
    {
      question: "Can I get a mortgage to finance a property in DAMAC Hills 2?",
      answer: "Yes, various financing options are available including mortgage solutions through our partner banks and financial institutions."
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="relative w-full h-screen flex flex-col items-center justify-center overflow-hidden">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          className="absolute inset-0 w-full h-full object-cover z-0"
          poster="/damac/DamacHills 2/DAMAC_Hills_2-Project_BG_Image_16x9.jpg"
          controls={false}
          disablePictureInPicture
          disableRemotePlayback
          onLoadStart={() => console.log('Video loading started')}
          onCanPlay={() => console.log('Video can play')}
          onError={(e) => console.log('Video error:', e)}
        >
          <source src="/damac/DamacHills 2/Damac_Hills_2_Hero_video__16x9_.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
        <div className="absolute inset-0 bg-black bg-opacity-40 z-10" />
        <div className="relative z-20 w-full flex flex-col items-center justify-center text-center px-4">
          <h1 className="text-4xl md:text-6xl font-light mb-4 text-white font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>DAMAC HILLS 2</h1>
        </div>
      </section>

      {/* Project Overview */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>ABOUT DAMAC HILLS 2</h2>
            <p className="text-lg text-gray-600 max-w-4xl mx-auto font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
              Whether you seek outdoor excitement or peaceful retreats, this family-friendly haven offers endless opportunities to live, laugh, and dream.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">55 MILLION SQ.FT.</h3>
              <p className="text-gray-600">Master community</p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">14,044</h3>
              <p className="text-gray-600">Villas and townhouses</p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">2,120</h3>
              <p className="text-gray-600">Apartments</p>
            </div>
            <div className="text-center">
              <h3 className="text-2xl font-bold text-gray-900 mb-2">2,127</h3>
              <p className="text-gray-600">Hotel rooms & hotel apartments</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Destination Section */}
      <section className="max-w-6xl mx-auto py-20 px-4">
          <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-light text-gray-900 mb-6 tracking-tight font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>The Destination</h2>
          </div>
          
            {amenities.map((amenity, index) => (
          <div key={index} className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index < amenities.length - 1 ? 'mb-20' : ''}`}>
            {index % 2 === 0 ? (
              // Image Left, Text Right
              <>
                <div className="relative">
                  <img src={amenity.image} alt={amenity.title} className="w-full h-96 object-cover rounded-lg" />
                </div>
                <div className="text-left">
                  <h3 className="text-2xl font-light text-gray-900 mb-4 font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.description}</p>
                  </div>
              </>
            ) : (
              // Text Left, Image Right
              <>
                <div className="text-left">
                  <h3 className="text-2xl font-light text-gray-900 mb-4 font-sans tracking-tight" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.title}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{amenity.description}</p>
                </div>
                <div className="relative">
                  <img src={amenity.image} alt={amenity.title} className="w-full h-96 object-cover rounded-lg" />
              </div>
              </>
            )}
          </div>
        ))}
      </section>

      {/* Community Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>WHERE MOMENTS BECOME MEMORIES</h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
              Explore the community through the eyes of those who call it home.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <img 
                src="/damac/DamacHills 2/DAMAC_Hills_2-Social_Image_9x16-1.jpg" 
                alt="Community Life 1"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>@damachills2community</p>
            </div>
            <div className="text-center">
              <img 
                src="/damac/DamacHills 2/DAMAC_Hills_2-Social_Image_9x16-2.jpg" 
                alt="Community Life 2"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>@damachills2community</p>
            </div>
            <div className="text-center">
              <img 
                src="/damac/DamacHills 2/DAMAC_Hills_2-Social_Image_9x16-3.jpg" 
                alt="Community Life 3"
                className="w-full h-64 object-cover rounded-lg mb-4"
              />
              <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>@damachills2community</p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Projects */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>FIND YOUR HOME PORT</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {featuredProjects.map((project, index) => (
              <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="h-48 overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-gray-900 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.name}</h3>
                  <p className="text-gray-600 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.location}</p>
                  {project.price && (
                    <p className="text-green-600 font-semibold mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.price}</p>
                  )}
                  {project.type && (
                    <p className="text-gray-500 text-sm mb-4 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{project.type}</p>
                  )}
                  <Link 
                    to="/contact" 
                    className="inline-block px-6 py-3 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans" 
                    style={{fontFamily: 'Roboto, sans-serif'}}
                  >
                    EXPLORE
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>FREQUENTLY ASKED QUESTIONS</h2>
          </div>
          
          <div className="space-y-6">
            {faqs.map((faq, index) => (
              <div key={index} className="bg-white rounded-lg shadow-md p-6">
                <h3 className="text-lg font-semibold text-gray-900 mb-3 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{faq.question}</h3>
                <p className="text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Contact Form */}
      <section className="py-20 bg-white">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light text-gray-900 mb-6 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>GET IN TOUCH</h2>
            <p className="text-lg text-gray-600 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
              Ready to discover your perfect home at DAMAC Hills 2? Contact us today.
            </p>
          </div>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Email *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                  style={{fontFamily: 'Roboto, sans-serif'}}
                />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Phone Number</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                style={{fontFamily: 'Roboto, sans-serif'}}
              />
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>Message</label>
              <textarea
                name="message"
                value={formData.message}
                onChange={handleChange}
                rows="4"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-black focus:border-transparent font-sans"
                style={{fontFamily: 'Roboto, sans-serif'}}
              ></textarea>
            </div>
            <div className="flex items-center">
                <input
                  type="checkbox"
                name="agreement"
                checked={formData.agreement}
                  onChange={handleChange}
                className="h-4 w-4 text-black focus:ring-black border-gray-300 rounded"
                />
              <label className="ml-2 text-sm text-gray-700 font-sans" style={{fontFamily: 'Roboto, sans-serif'}}>
                I agree to receive updates on WhatsApp
              </label>
            </div>
            <div className="text-center">
            <button
              type="submit"
                className="px-8 py-4 bg-black text-white font-medium hover:bg-gray-800 transition-colors duration-200 font-sans"
                style={{fontFamily: 'Roboto, sans-serif'}}
            >
              SUBMIT
            </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default DamacHills2Page; 